export default __webpack_public_path__ + "static/media/livingRoom.69a9ecf7.jpeg";